import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=c6039d50&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=c6039d50&prod&scoped=true&lang=css"
import style1 from "./Contact.vue?vue&type=style&index=1&id=c6039d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6039d50",
  null
  
)

export default component.exports